export enum DesktopAudioRecorderFailureReason {
  DesktopRecorderStartFailed = "desktop-recorder-start-failed",
}

export type SystemAudioRecordingFailedContext = {
  reason: DesktopAudioRecorderFailureReason;
};
